import { Navigate, useParams } from "react-router";
import { PRODUCT_DATA } from "../../../data/productData";
import { UnifiedProductPage } from "./UnifiedProductPage";

const SLUG_REDIRECTS: Record<string, string> = {
  "insert-cards": "textile-home-packaging",
  "hang-tags": "garment-packaging",
  "folding-carton": "luxury-packaging",
  "folding-cartons": "luxury-packaging",
  "corrugated-boxes": "custom-packaging",
  "paper-bags": "business-print-materials",
  "eco-packaging": "eco-friendly-packaging",
  "pdq-displays": "retail-display-packaging",
};

export function ProductSlugPage() {
  const { slug = "" } = useParams();

  if (SLUG_REDIRECTS[slug]) {
    return <Navigate to={`/products/${SLUG_REDIRECTS[slug]}`} replace />;
  }

  const content = PRODUCT_DATA[slug];

  if (content) {
    return <UnifiedProductPage key={slug} content={content} />;
  }

  if (slug === "rigid-boxes") return <Navigate to="/products" replace />;

  return <Navigate to="/products" replace />;
}
